// Route search of the suggestion inbox. Kept free of zod / @patronix/domain:
// route config is part of the initial bundle (search.test.ts checks the list
// against the domain's).

export const inboxStatuses = ["proposed", "executed", "rejected", "expired", "superseded"] as const;
export type InboxStatus = (typeof inboxStatuses)[number];

export interface InboxSearch {
  status: InboxStatus;
  id?: string | undefined;
}

export function validateInboxSearch(raw: Record<string, unknown>): InboxSearch {
  const status = inboxStatuses.includes(raw.status as InboxStatus) ? (raw.status as InboxStatus) : "proposed";
  const s: InboxSearch = { status };
  if (typeof raw.id === "string" && /^[0-9a-f-]{36}$/i.test(raw.id)) s.id = raw.id;
  return s;
}
